export default {
    root: {
        class: [
            // Shape
            "rounded-md shadow-lg",
            "border-0 dark:border",

            // Position
            "absolute left-0 top-0 mt-1",
            "z-40 transform origin-right",
            '[&[data-p-popover-flipped="true"]]:mb-3 [&[data-p-popover-flipped="true"]]:-mt-3',

            // Color
            "bg-white dark:bg-stone-800",
            "text-stone-700 dark:text-stone-50/80",
            "dark:border-stone-700",

            // Arrow
            // 'before:absolute before:w-0 before:-top-3 before:h-0 before:border-transparent before:border-solid before:ml-[10px] before:border-x-[10px] before:border-b-[10px] before:border-t-0 before:border-b-stone-200 dark:before:border-b-stone-700',
            // 'after:absolute after:w-0 after:-top-[0.54rem] after:left-[4px] after:h-0 after:border-transparent after:border-solid after:ml-[8px] after:border-x-[8px] after:border-b-[8px] after:border-t-0 after:border-b-stone-50 dark:after:border-b-stone-800',

            // Flipped: Arrow
            // '[&[data-p-popover-flipped="true"]]:before:-bottom-3 [&[data-p-popover-flipped="true"]]:before:top-auto [&[data-p-popover-flipped="true"]]:before:border-b-0 [&[data-p-popover-flipped="true"]]:before:border-t-[10px] [&[data-p-popover-flipped="true"]]:before:border-t-stone-200 dark:[&[data-p-popover-flipped="true"]]:before:border-t-stone-700',
            // '[&[data-p-popover-flipped="true"]]:after:-bottom-[0.54rem] [&[data-p-popover-flipped="true"]]:after:top-auto [&[data-p-popover-flipped="true"]]:after:border-b-0 [&[data-p-popover-flipped="true"]]:after:border-t-[8px] [&[data-p-popover-flipped="true"]]:after:border-t-stone-50 dark:[&[data-p-popover-flipped="true"]]:after:border-t-stone-800'
        ],
    },
    content: {
        class: "p-5 items-center flex",
    },
    transition: {
        enterFromClass: "opacity-0 scale-y-[0.8]",
        enterActiveClass: "transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]",
        leaveActiveClass: "transition-opacity duration-100 ease-linear",
        leaveToClass: "opacity-0",
    },
};
